import {getIconByKey} from 'shells/billing/helpers';

import type {GetAvailablePlans_recurlyAvailablePlans_crm_plans as Plan} from 'nutshell-graphql-types';

import type {Label, Variant} from './plan-card';

export function findPlanByName(plans: Plan[], planName: string): Plan | undefined {
    const normalized = planName.toLowerCase().trim();

    if (!normalized) {
        return undefined;
    }

    return plans.find((plan) => plan.name.toLowerCase().includes(normalized));
}

export function getPerUserLimit(totalLimit: number, numSeats: number): number {
    if (numSeats <= 0) {
        return totalLimit;
    }

    return Math.round(totalLimit / numSeats);
}

export function getPlanPill(planName: string): React.ReactNode {
    const normalized = planName.toLowerCase().trim();

    // getIconByKey uses plan keys like 'pro', 'business', 'enterprise', 'foundation'
    const pill = getIconByKey(normalized);

    if (pill) {
        return pill;
    }

    // Fallback: try matching partial names (e.g. "Nutshell Pro" -> "pro")
    const knownKeys = ['enterprise', 'pro', 'business', 'foundation', 'growth'] as const;
    for (const key of knownKeys) {
        if (normalized.includes(key)) {
            return getIconByKey(key);
        }
    }

    return getIconByKey('foundation');
}

export function getBadgeLevel(label: Label, variant: Variant) {
    if (label === 'Recommended') {
        return variant === 'highlighted' ? 'info--purple' : 'success';
    }
    return 'info--grey';
}
